export var IDs = {
    SITE_NAME: 'site.name',
    BUSINESS_NAME: 'site.business.name',
    INDEX_SITE: 'site.index',
    INDEX_PAGE: 'page.index',
    ID: 'product.id',
    SKU: 'product.sku',
    TITLE: 'product.name',
    DESCRIPTION: 'product.description',
    BRAND: 'product.brand',
    PRICE: 'product.price',
    CURRENCY: 'product.currency',
    TYPE: 'product.type',
    WEIGHT: 'product.weight',
    AVAILABILITY_SCHEMA: 'product.availability.schema',
    AVAILABILITY_META_TAG: 'product.availability.metaTag',
    SLUG: 'product.slug',
    MAIN_IMAGE: 'product.image.url',
    IMAGE_WIDTH: 'product.image.width',
    IMAGE_HEIGHT: 'product.image.height',
    IMAGE_ALT: 'product.image.alt',
    THUMBNAIL_URL: 'product.thumbnail.url',
    THUMBNAIL_WIDTH: 'product.thumbnail.width',
    THUMBNAIL_HEIGHT: 'product.thumbnail.height',
    THUMBNAIL_ALT: 'product.thumbnail.alt',
    SD_JSON_IMAGES: 'product.structured-data.images',
    PAGE_URL: 'product.url',
    PRODUCT_PAGE_BASE_URL: 'product.baseUrl',
    DISABLE_SCHEMA: 'product.disable-schema',
    MEDIA_ITEMS: 'product.media',
    FULL_DESCRIPTION: 'product.full-description',
};
